import React, { useEffect, useState } from 'react';
import { getLogs } from '../../services/LogsService';

/**
 * props:
 * - file
 */
function LogView(props) {

    const [logs, setLogs] = useState('');

    useEffect(() => {
        if (!props.file) return;
        getLogs(props.file)
            .then(logs => setLogs(logs))
            .catch(err => setLogs(err.response ? err.response.data : err.message));
    }, [props.file])

    return (
        <React.Fragment>
            <div className="mb-3">
                <label htmlFor="logs">Logs:</label>
                {/* Log lines are long; the textarea scrolls itself instead of the page. */}
                <textarea id="logs" defaultValue={logs} rows={14} className="form-control font-monospace" style={{ fontSize: '.78rem', whiteSpace: 'pre', overflowX: 'auto' }} />
            </div>
        </React.Fragment>
    )
}

export default LogView;